import { executeNetworkAsync } from "../../helper/handler/network";
import { clientAxiosInstance } from "../../types/swrFetcher";

/**
 * @param  {string} email
 * @param  {string} otp
 * @param  {string} type
 */

export const verifyResetPasswordToken = async (
  email: string,
  code: string,
  type: string
) => {
  const networkCall = async () =>
    await clientAxiosInstance().post(`/api/auth/verifyResetPasswordToken`, {
      email,
      code,
      type,
    });

  const [result, error] = await executeNetworkAsync(networkCall);
  return [result, error];
};
